import { COUNTRIES, RU } from 'constants/countries'
import { SALES_RUS } from 'constants/sales'
import { getCartLabels } from 'utils/cart'

const getCartOptions = (cart, dict, cartDict, sales) => ({
  countryCode: COUNTRIES[RU].alpha2Code,
  currencyCode: SALES_RUS,
  supportedNetworks: ['visa', 'masterCard'],
  merchantCapabilities: ['supports3DS'],
  total: {
    label: cartDict.total.title,
    amount: cart.sum.cost,
  },
  lineItems: getCartLabels(cart, dict, cartDict, sales || {}),
})

export default getCartOptions
